import PreloadDropzone, {FileWithPreview} from "./PreloadDropzone";

export type {FileWithPreview};
export default PreloadDropzone;